/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
// import { useEnvStore } from '../env';
import { useSubscriberStore } from '.';


function useSubscriber (p) {
    const subscriber = useSubscriberStore();

    const [isPolling, setIsPolling] = useState(false);
 
    useEffect(() => {
       setIsPolling(subscriber.isStatusPolling);
    }, [subscriber.observed.isStatusPolling]);

    return {
        isPolling,
    };
}

export default useSubscriber;